import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "d-flex align-center justify-space-between w-100" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "text-body-2" }
const _hoisted_5 = { class: "pa-4 mt-2 border rounded" }
const _hoisted_6 = { class: "d-flex justify-space-between align-center" }
const _hoisted_7 = { class: "text-body-1" }
const _hoisted_8 = { class: "text-body-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-subtitle-2 font-weight-semibold mt-1"
}
const _hoisted_10 = { class: "text-caption mt-2" }

import { computed } from 'vue'
import { useStore } from '@/app/store'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectedRoom',
  props: {
    index: {}
  },
  emits: ["remove"],
  setup(__props: any) {

const props = __props



const store = useStore()
const { t } = useI18n()

const bookingRequest = computed(() => store.getters.bookingRequest)

const title = computed(() => {
  const ordinals = [
    t('Search#Form First selected room'),
    t('Search#Form Second selected room'),
    t('Search#Form Third selected room'),
    t('Search#Form Fourth selected room')
  ]
  return ordinals[props.index]
})

const roomStayGuests = computed(
  () => bookingRequest.value.roomStays[props.index]
)
const roomStay = computed(() => roomStayGuests.value.order)
const roomName = computed(() => roomStay.value.room.roomTypeName)
const ratePlanName = computed(() => roomStay.value.rate?.ratePlanName)
const price = computed(
  () =>
    `${roomStay.value.currency} ${roomStayGuests.value.totalDiscountedPrice.toFixed(2)}`
)

const occupancy = computed(() => {
  const { nbAdults, nbChildren, nbInfants } = roomStay.value

  let str = t('Search#Form#Field#NumAdults Adults', nbAdults)

  if (nbChildren > 0) {
    str += ', ' + t('Search#Form#Field#NumChildren Children', nbChildren)
  }

  if (nbInfants > 0) {
    str += ', ' + t('Search#Form#Field#NumInfants Infants', nbInfants)
  }

  return str
})

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_fa_icon, {
          class: "mr-2",
          icon: ['far', 'user']
        }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(title.value), 1)
      ]),
      _createVNode(_component_v_btn, {
        class: "pa-0",
        slim: "",
        variant: "text",
        "min-width": 25,
        height: 25,
        ripple: false,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('remove', _ctx.roomStayIndex)), ["stop","prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_fa_icon, {
            class: "text-body-1",
            icon: ['fas', 'xmark']
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(roomName.value), 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(price.value), 1)
      ]),
      (ratePlanName.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(ratePlanName.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, "(" + _toDisplayString(occupancy.value) + ")", 1)
    ])
  ]))
}
}

})